import { Action } from 'redux';

export type ResourceId = StringOrNumber;

export type ResourceData = any;

export type ResourceName = string;

export enum CacheActions {
  SET_CACHE = 'SET_CACHE',
  REMOVE_CACHE = 'REMOVE_CACHE',
}

export interface CacheAction extends Action {
  payload: {
    entity: ResourceName;
    id?: ResourceId;
    entityData?: ResourceData;
  };
}

export interface CacheEntry<TEntity = ResourceData> {
  id: ResourceId;
  entityData: TEntity;
}

export interface CacheState<TEntity = ResourceData> {
  [entity: string]: {
    id: ResourceId;
    entityData: TEntity;
  };
}
